module.exports = __webpack_public_path__ + "static/img/banner_list.6525dce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_list.jpg
// module id = 4I9U
// module chunks = 2